import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./pages/Footer/Footer";
import Home from "./pages/Home/Home";
import AboutPage from "./pages/AboutPage/AboutPage";
import NewsRoom from "./pages/NewsRoom/NewsRoom";
import NewsRoomPage from "./pages/NewsRoomPage/NewsRoomPage";
import Projects from "./pages/Projects/Projects";
import ProjectPage from "./pages/ProjectPage/ProjectPage";
import ContactPage from "./pages/ContactPage/ContactPage";
import Blog from "./pages/Blog/Blog";
import BlogPage from "./pages/BlogPage/BlogPage";
import Careers from "./pages/Careers/Careers";
import History from "./pages/History/History";
import Leadership from "./pages/Leadership/Leadership";
import ProductPage from "./pages/ProductPage/ProductPage";
import Products from "./pages/Products/Products";
import Services from "./pages/Services/Services";
import ServicePage from "./pages/ServicePage/ServicePage";

import Admin from "./pages/Admin/Admin";
import AdminDevFeedback from "./pages/AdminDevFeedback/AdminDevFeedback";
import AdminSiteEditor from "./pages/AdminSiteEditor/AdminSiteEditor";
import AdminProjects from "./pages/AdminProjects/AdminProjects";
import AdminNews from "./pages/AdminNews/AdminNews";
import AdminBlog from "./pages/AdminBlog/AdminBlog";
import AdminProducts from "./pages/AdminProducts/AdminProducts";
import AdminServices from "./pages/AdminServices/AdminServices";
import AdminHiring from "./pages/AdminHiring/AdminHiring";
import AdminSubmission from "./pages/AdminSubmission/AdminSubmission";
import AdminFiles from "./pages/AdminFiles/AdminFiles";
import AddProjectsPage from "./pages/AddProjectsPage/AddProjectsPage";
import AddServicesPage from "./pages/AddServicesPage/AddServicesPage";
import AddNewsPage from "./pages/AddNewsPage/AddNewsPage";
import AddHiringPage from "./pages/AddHiringPage/AddHiringPage";
import AddBlogPage from "./pages/AddBlogPage/AddBlogPage";
import AddProductsPage from "./pages/AddProductsPage/AddProductsPage";
import EditProjectsPage from "./pages/EditProjectsPage/EditProjectsPage";
import EditBlogPage from "./pages/EditBlogPage/EditBlogPage";
import EditProductsPage from "./pages/EditProductsPage/EditProductsPage";
import EditServicesPage from "./pages/EditServicesPage/EditServicesPage";
import EditNewsPage from "./pages/EditNewsPage/EditNewsPage";
import EditHiringPage from "./pages/EditHiringPage/EditHiringPage";
import EditSubmissionPage from "./pages/EditSubmissionPage/EditSubmissionPage";
import Login from "./pages/Login/Login";
import PrivateRoute from "./pages/PrivateRoute/PrivateRoute";
import NotFound from "./pages/NotFound/NotFound";

const PublicLayout = ({ children }) => (
  <>
    <NavBar />
    {children}
    <Footer />
  </>
);

// Private Layout Wrapper
const PrivateLayout = ({ children }) => <>{children}</>;

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
        <Route path="/news" element={<PublicLayout><NewsRoom /></PublicLayout>} />
        <Route path="/news/:id" element={<PublicLayout><NewsRoomPage /></PublicLayout>} />
        <Route path="/project" element={<PublicLayout><Projects /></PublicLayout>} />
        <Route path="/project/:id" element={<PublicLayout><ProjectPage /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
        <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
        <Route path="/blog/:id" element={<PublicLayout><BlogPage /></PublicLayout>} />
        <Route path="/careers" element={<PublicLayout><Careers /></PublicLayout>} />
        <Route path="/history" element={<PublicLayout><History /></PublicLayout>} />
        <Route path="/leadership" element={<PublicLayout><Leadership /></PublicLayout>} />
        <Route path="/products/:id" element={<PublicLayout><ProductPage /></PublicLayout>} />
        <Route path="/products" element={<PublicLayout><Products /></PublicLayout>} />
        <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
        <Route path="/services/:id" element={<PublicLayout><ServicePage /></PublicLayout>} />

        {/* Private Routes */}
        <Route path="/admin" element={<PrivateRoute><PrivateLayout><Admin /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/editor" element={<PrivateRoute><PrivateLayout><AdminSiteEditor /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/feedback" element={<PrivateRoute><PrivateLayout><AdminDevFeedback /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/projects" element={<PrivateRoute><PrivateLayout><AdminProjects /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/products" element={<PrivateRoute><PrivateLayout><AdminProducts /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/blog" element={<PrivateRoute><PrivateLayout><AdminBlog /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/services" element={<PrivateRoute><PrivateLayout><AdminServices /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/news" element={<PrivateRoute><PrivateLayout><AdminNews /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/hiring" element={<PrivateRoute><PrivateLayout><AdminHiring /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/submission" element={<PrivateRoute><PrivateLayout><AdminSubmission /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/files" element={<PrivateRoute><PrivateLayout><AdminFiles /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/add-projects" element={<PrivateRoute><PrivateLayout><AddProjectsPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/add-products" element={<PrivateRoute><PrivateLayout><AddProductsPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/add-blog" element={<PrivateRoute><PrivateLayout><AddBlogPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/add-news" element={<PrivateRoute><PrivateLayout><AddNewsPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/add-hiring" element={<PrivateRoute><PrivateLayout><AddHiringPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/add-services" element={<PrivateRoute><PrivateLayout><AddServicesPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/projects/:id" element={<PrivateRoute><PrivateLayout><EditProjectsPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/products/:id" element={<PrivateRoute><PrivateLayout><EditProductsPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/services/:id" element={<PrivateRoute><PrivateLayout><EditServicesPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/hiring/:id" element={<PrivateRoute><PrivateLayout><EditHiringPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/news/:id" element={<PrivateRoute><PrivateLayout><EditNewsPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/blog/:id" element={<PrivateRoute><PrivateLayout><EditBlogPage /></PrivateLayout></PrivateRoute>} />
        <Route path="/admin/submission/:id" element={<PrivateRoute><PrivateLayout><EditSubmissionPage /></PrivateLayout></PrivateRoute>} />

        {/* Login Route */}
        <Route path="/login" element={<Login />} />

        {/* 404 Not Found Route */}
        <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
